// extracted by mini-css-extract-plugin
export default {"wrapper":"QurealSection_wrapper__8YbsG","content":"QurealSection_content__0BtEJ","header_wrapper":"QurealSection_header_wrapper__31ykw"};